// LandingLoadingShell — full-viewport dark shell shown while landing kill-switches
// resolve. Prevents FOUC/flash between LandingV1 and LandingV2 on root `/`.
// Zero content (only bg + logo) → looks identical regardless of which landing
// will win the priority chain (V2 > V1 > legacy).
import React from "react";

export default function LandingLoadingShell() {
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-bg"
            data-testid="landing-loading-shell"
            aria-hidden="true"
        >
            <div className="flex items-center gap-3 opacity-70">
                <span className="w-10 h-10 rounded-xl bg-white flex items-center justify-center text-black font-bold text-lg">
                    G
                </span>
                <span className="text-text-main font-semibold text-xl tracking-tight">
                    Global Lead Suite
                </span>
            </div>
        </div>
    );
}
